const ns_groups = {
	how_to_use_section: `Dies sind Alles-oder-Nichts-Einstellungen. Also ein Name ist nicht und ein anderer Domainname ist, funktioniert nicht.
		Der Kunde hat eigene Nameserver? Dann kann er seine DNS nicht im Portal verwalten.
		Der Kunde möchte unsere Nameserver mit seinem eigenen Namen verwenden?

		Informieren Sie einen Techniker, dass Sie das tun werden und teilen Sie ihm die Namen mit (z.B. n1.kundenname.de und ns2.kundenname.de. kundenname.de muss bei uns sein!)
		Erstellen Sie eine Nameservergruppe in OXXA mit diesen Namen
		Warten Sie auf die Genehmigung des Ingenieurs.
		Fügen Sie dann diese Nameservergruppe in Portal hinzu und verknüpfen Sie sie mit dem Schuldner

		Wenn Sie nichts einstellen, werden standardmäßig die Nameserver von Tuxis verwendet, was auch die gewünschte Einstellung ist. 
		Wenn Sie diese Einstellung zwischendurch ändern, gilt sie für alle Neuregistrierungen. Alte Registrierungen werden nicht geändert. 
		Mit OXXA können Sie also auch eine Nameservergruppe löschen.`,
	table: {
		headers: {
			alias: "Alias",
			company: "Unternehmen",
			debtor: "Debitor",
			is_external: "Eigene Nameserver?",
			ns_overview: "Übersicht der Nameserver",
			oxxa_handle: "Oxxa-Handle",
		},
	},
	title: "Benutzerdefinierte NS-Gruppen", // Custom NS Groups
};

export default ns_groups;
